import { Box, Typography } from "@mui/material";
import { healthStyles as s } from "../styles/styles";

// "Order quality" metric card — the headline number + status pill on the left,
// and a small last-3-months table on the right (inside the same block).
// `tone` is { color, bg }. `trend` is an array of [monthLabel, value] pairs.
const HealthStat = ({ label, value, tone, statusText, tooltip, trend }) => (
  <Box sx={s.card}>
    <Box sx={s.main}>
      <Box sx={s.labelRow}>
        <Typography sx={s.label}>{label}</Typography>
        {tooltip}
      </Box>
      <Typography sx={{ ...s.value, color: tone.color }}>{value}</Typography>
      {statusText && (
        <Box sx={{ ...s.pill, color: tone.color, backgroundColor: tone.bg }}>
          {statusText}
        </Box>
      )}
    </Box>

    {trend && trend.length > 0 && (
      <Box sx={s.trend}>
        {trend.map((row, i) => (
          <Box key={i} sx={s.trendRow}>
            <Typography sx={s.trendMonth}>{row[0]}</Typography>
            <Typography sx={s.trendVal}>{row[1]}</Typography>
          </Box>
        ))}
      </Box>
    )}
  </Box>
);

export default HealthStat;
